import React, { useEffect, useState } from "react";
import { Row, Label, Input, Form, FormGroup, Button } from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import {
  getEconomicActivitiesPublic,
  getFundsType,
  getIncomeRanges,
} from "../../../helpers/AuthType/authBackend";
import { setAuthorization } from "../../../helpers/api_helper";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const FinancialInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  const [incomeRanges, setIncomeRanges] = useState<any[]>([]);
  const [fundsType, setFundsTypes] = useState<any[]>([]);
  const [economicActivities, setEconomicActivities] = useState<any[]>([]);

  const getData = async () => {
    const responseIncomeRanges = await getIncomeRanges();
    setIncomeRanges(JSON.parse(responseIncomeRanges.data));
    const responseFundTypes = await getFundsType(1);
    console.log();
    setFundsTypes(JSON.parse(responseFundTypes.data));
    const responseEcoActivities = await getEconomicActivitiesPublic();
    setEconomicActivities(JSON.parse(responseEcoActivities.data));
    // console.log({ responseEcoActivities });
  };

  useEffect(() => {
    const responsePublicToken = localStorage.getItem("publicToken");
    setAuthorization(responsePublicToken);
    getData();
  }, []);

  const formik: any = useFormik({
    initialValues: {
      economic_activity:
        (data.financialInfo && data.financialInfo.economic_activity) || "",
      monthly_income:
        (data.financialInfo && data.financialInfo.monthly_income) || "",
      income_origin:
        (data.financialInfo && data.financialInfo.income_origin) || "",
      isPEP: (data.financialInfo && data.financialInfo.isPEP) || false,
      acceptDeclaration:
        (data.financialInfo && data.financialInfo.acceptDeclaration) || false,
    },
    validationSchema: yup.object().shape({
      economic_activity: yup
        .string()
        .required("Please Select a economic activity"),
      monthly_income: yup
        .string()
        .required("Please select a range of your monthly income"),
      income_origin: yup.string().required("Please select an option"),
      isPEP: yup.boolean().required(""),
      acceptDeclaration: yup.boolean().required(""),
    }),
    onSubmit: (values: any) => {
      // console.log(values);
      values.economic_activity = parseInt(values.economic_activity);
      values.monthly_income = parseInt(values.monthly_income);
      values.income_origin = parseInt(values.income_origin);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        <Row>
          {/* ACIVIDAD ECONOMICA */}
          <FormGroup className="mb-3">
            <Label htmlFor="economic_activity"> Actividad Economica </Label>
            <select
              className="form-control"
              name="economic_activity"
              id="economic_activity"
              value={formik.values.economic_activity || ""}
              onChange={formik.handleChange}
            >
              <option value="" selected disabled>
                Elige una opcion
              </option>
              {economicActivities.map((item) => (
                <option id={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            {formik.errors.economic_activity &&
            formik.touched.economic_activity ? (
              <span className="text-danger">
                {formik.errors.economic_activity}
              </span>
            ) : null}
          </FormGroup>
          {/* INGRESO MENSUAL */}
          <FormGroup className="mb-3">
            <Label htmlFor="monthly_income"> Ingreso mensual estimado </Label>
            <select
              className="form-control"
              name="monthly_income"
              id="monthly_income"
              value={formik.values.monthly_income || ""}
              onChange={formik.handleChange}
            >
              <option value="" selected disabled>
                Elige una opcion
              </option>
              {incomeRanges.map((item) => (
                <option id={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            {formik.errors.monthly_income && formik.touched.monthly_income ? (
              <span className="text-danger">
                {formik.errors.monthly_income}
              </span>
            ) : null}
          </FormGroup>
          {/* ORIGEN DE FONDOS */}
          <FormGroup tag="fieldset" className="mb-3">
            <Label
              htmlFor="income_origin"
              className="col-form-label"
              style={{ fontSize: "15px" }}
            >
              Origen de fondos
            </Label>
            <div style={{ marginLeft: "20px", fontSize: "14px" }}>
              {fundsType.map((item) => (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="income_origin"
                      id="income_origin"
                      value={String(item.id)}
                      onChange={formik.handleChange}
                      checked={formik.values.income_origin === String(item.id)}
                    />{" "}
                    {item.name}
                  </Label>
                </FormGroup>
              ))}
            </div>
            {formik.touched.income_origin && formik.errors.income_origin ? (
              <div className="text-danger">{formik.errors.income_origin}</div>
            ) : null}
          </FormGroup>

          {/* CHECKBOX */}
          {/* BLOQUE PEP */}
          <FormGroup className="mb-4">
            {/* Título */}
            <Label tag="h6">Información sobre PEP</Label>
            {/* Texto largo con scroll */}
            <div
              style={{
                maxHeight: "120px",
                overflowY: "auto",
                padding: "8px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <p>
                De acuerdo con la Ley Contra el Lavado de Dinero y de Activos y
                las normas de la Superintendencia del Sistema Financiero (SSF),
                se considera PEP a:
                <br />
                <br />
                “Las personas naturales que desempeñan o han desempeñado
                funciones públicas destacadas en un país o en una organización
                internacional, incluyendo jefes de Estado o de Gobierno, altos
                funcionarios gubernamentales, judiciales o militares, altos
                ejecutivos de empresas estatales o importantes partidos
                políticos.”
              </p>
            </div>
            {/* Checkbox */}
            <FormGroup check className="mt-2">
              <Label check>
                <Input
                  type="checkbox"
                  name="isPEP"
                  onChange={formik.handleChange}
                  checked={formik.values.isPEP}
                />
                Marque acá si usted es una{" "}
                <span
                  style={{ color: "blue", textDecorationLine: "underline" }}
                >
                  persona políticamente expuesta (PEP)
                </span>
              </Label>
              {formik.touched.isPEP && formik.errors.isPEP ? (
                <div className="text-danger">{formik.errors.isPEP}</div>
              ) : null}
            </FormGroup>
          </FormGroup>
          <hr
            style={{
              borderTopColor: "black",
              borderTopWidth: 0.1,
              borderTopStyle: "solid",
            }}
          />
          {/* BLOQUE DECLARACIÓN */}
          <FormGroup className="mb-4">
            {/* Título */}
            <Label tag="h6">Declaración de Origen de Fondos</Label>
            {/* Texto largo con scroll */}
            <div
              style={{
                maxHeight: "120px",
                overflowY: "auto",
                padding: "8px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <p>
                Yo, declaro bajo juramento, que los fondos o valores que
                entregaré a DITOBANX EL SALVADOR, S.A. DE C.V. los cuales tienen
                un origen y destino lícito y que de ninguna manera están
                relacionados con los delitos generadores de Lavado de Dinero y
                Activos descritos en el artículo 6 de la ley contra el lavado de
                Dinero y Activos, con el financiamiento del Terrorismo, ni con
                ningún tipo de actividad ilícita. Declaro que la información
                suministrada en este formulario es verdadera, es completa y se
                encuentra actualizada a la fecha de hoy. Además, acepto que
                cualquier declaración falsa o inexactitud en el contenido del
                presente documento será causa de terminación inmediata de
                cualquier acuerdo o relación comercial actualmente existente o
                futura con DITOBANX EL SALVADOR, S.A. DE C.V., así mismo
                autorizo a DITOBANX EL SALVADOR, S.A DE C.V. para que pueda
                confirmar la veracidad de la información proporcionada. Además,
                declaro que la persona jurídica que represento, miembros del
                órgano de administración superior, accionistas, representantes
                legales y administradores, no estamos incluidos en los listados
                de la Oficina del Control de Activos Extranjeros (OFAC), o en
                otro listado de similar naturaleza, o en algún listado de
                carácter nacional y/o internacional en la que se publiquen
                nombres de personas o entidades a quienes se les haya iniciado
                procesos judiciales, actuación administrativa o que hayan sido
                sancionados y/o condenados por las autoridades con actividades
                ilegales relacionadas al lavado de dinero y/o financiamiento del
                terrorismo.
              </p>
            </div>
            {/* Checkbox */}
            <FormGroup check className="mt-2">
              <Label check>
                <Input
                  type="checkbox"
                  name="acceptDeclaration"
                  onChange={formik.handleChange}
                  checked={formik.values.acceptDeclaration}
                />
                Acepto la Declaración jurada del origen de los fondos
              </Label>
              {formik.touched.acceptDeclaration &&
              formik.errors.acceptDeclaration ? (
                <div className="text-danger">
                  {formik.errors.acceptDeclaration}
                </div>
              ) : null}
            </FormGroup>
          </FormGroup>
        </Row>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {/* <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onBack}
          >
            Regresar
          </button> */}
          <Button type="submit" className="btn btn-primary">
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default FinancialInformation;
